import { Component } from '@angular/core';
import { NavController, ToastController } from 'ionic-angular';
import { AngularFireAuth } from 'angularfire2/auth';
import { LoginPage } from "../login/login";
import {Data} from "../../providers/providers";

@Component({
  selector: 'page-logout',
  templateUrl: 'logout.html'
})
export class LogoutPage {

  constructor(public navCtrl: NavController,
              private firebaseAuth: AngularFireAuth,
              public data: Data)
  {}

  doLogout() {
    this.firebaseAuth
      .auth
      .signOut()
      .then(value => {
        this.navCtrl.goToRoot({});
      });
  }
}



// WEBPACK FOOTER //
// ./src/pages/logout/logout.ts